import axios from "axios";
import { apiAdmin } from "./api";
import { authorize } from "../shared/authorize";
import dropin from "braintree-web-drop-in";

export const fetchPaypalToken = async () => {
  try {

    const response = await apiAdmin.get('user/paypal/token', {
      ...authorize(),
      timeout: 10000, // 10 seconds timeout, adjust as needed
    });

    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.code === 'ECONNABORTED') {
        console.error("Request timed out. Please try again.");
        // Optionally notify the user with a toast or UI alert
        return null; // or handle gracefully in another way
      } else {
        console.error("Axios error occurred:", error.message);
      }
    } else {
      console.error("Unexpected error:", error);
    }

    return null; // Return a default/fallback value instead of throwing
  } finally {
  }
};
 

export const generateNonceWithDropIn = async (userToken, containerId, amount) => {
  return new Promise((resolve, reject) => {
    const rawId = containerId.startsWith("#") ? containerId.slice(1) : containerId;
    const containerEl = document.getElementById(rawId);
    if (containerEl) {
      containerEl.innerHTML = "";
    }

    dropin.create(
      {
        authorization: userToken, // Client token from your server
        container: `#${rawId}`, // Container ID for the Drop-In UI
        paypal: {
          flow: "checkout", // Use "checkout" for one-time payments
          amount: amount, // Transaction amount
          currency: "EUR", // Transaction currency
          locale: navigator.language.startsWith("en") ? "en_US" : "es_ES",
        },
      },
      (error, instance) => {
        if (error) {
          console.error("Drop-In creation error:", error);
          reject(error);
          return;
        }

        // Automatically tokenize when a payment option is selected
        instance.on("paymentMethodRequestable", () => {
          instance.requestPaymentMethod((err, payload) => {
            if (err) {
              console.error("Error requesting payment method:", err);
              reject(err);
              return;
            }

            // Resolve with the nonce
            resolve(payload.nonce);
          });
        });

        // Handle errors during payment method selection
        instance.on("noPaymentMethodRequestable", () => {
          console.error("No payment method available");
        });
      }
    );
  });
};
  




